export default __webpack_public_path__ + "static/media/logo.84382d78.svg";